<template>
  <!-- 框框加文字 -->
  <div class="id_2">
    <div class="o_div">
      <div class="top clear">
        <div class="img_box fl" v-if="data.src">
          <img :src="data.src">
        </div>

        <div class="title bold fl" v-html="data.title"></div>
      </div>

      <div class="concent">

        <div class="text" v-html="data.text"></div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  name: 'id_2',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.id_2{
  .text{
    font-size: 16px;
    line-height: 26px;
    color: #333;
    word-wrap:break-word;
    .img_id2{
      width: 100%;
      max-width: 100%;
      margin-top: 24px;
    }
    .img_title{
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #909399;
      margin-top: 16px;
    }
  }
}
</style>

<style lang="scss" scoped>
.id_2{
  padding-top: 40px;
  background-color: #fff;
  .o_div{
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 24px;
    position: relative;
    .top{
      position: absolute;
      background: #fff;
      padding: 0 8px;
      top: -14px;
      left: 16px;
      .img_box{
        width: 30px;
        height: 30px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .title{
        line-height: 30px;
        font-size: 20px;
        line-height: 28px;
        padding-left: 8px;
        color: #303133;
      }
    }
    .text{
      font-size: 16px;
      line-height: 26px;
      color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_2.vue